import React, { useEffect, useState, useContext } from "react";
import { Table, Modal, Tag } from "antd";
import { PlusCircle, Eye } from "react-feather";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CreateLeaveTypeModal from "../../core/modals/hrm/createLeaveAllocation";
import EditLeaveTypeModal from "../../core/modals/hrm/editLeaveAllocation";
import {
  getAllLeaveAllocations,
  deleteLeaveAllocation,
  fetchSearchAllocation,
} from "../../service/leaveAllocationService";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import okilogo from "../../assets/OKI-logo.png";
import ExcelJS from "exceljs";
import BulkUploadModal from "../../feature-module/hrm/leaveAllocation-bulk_upload";
import { DatePicker, Select } from "antd";
import { getAllLeaveTypes } from "../../service/leaveApiServices/leaveTypesApi";
import { getAllDepartments } from "../../service/departmentService";
import { ArrowLeft } from "lucide-react";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const JobType = () => {
  const { user } = useContext(UserContext);
  const currentYear = dayjs().year();
  const [data, setData] = useState([]);
  const [isLeaveTypeAdd, setIsLeaveTypeAdd] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedLeaveBalances, setSelectedLeaveBalances] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false);
  const [empType, setEmpType] = useState(null);
  const [leaveTypeOptions, setleaveTypeOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [epf_number, setEpf] = useState("");
  const [name, setName] = useState("");
  const [searchYear, setSearchYear] = useState(currentYear);
  const [selectedLeaveTypeOption, setSelectedLeaveTypeOption] = useState(null);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 });
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false);
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize);
  const pageSizeOptions = [5, 10, 20, 50, 100];

  const employeeTypes = [
    { value: "Academic", label: "Academic" },
    { value: "Non Academic", label: "Non Academic" },
  ];

  const handleSearchYearChange = (date, dateString) => {
    setSearchYear(dateString);
  };

  const handleChangeLeaveType = (value, option) => {
    setSelectedLeaveTypeOption(option);
  };

  const handleChangeDepartment = (value, option) => {
    setSelectedDepartment(option);
  };

  const fetchData = async () => {
    setLoading(true);
    const fetchdata = await getAllLeaveAllocations({ search: "", setLoading });
    setData(fetchdata);
    setLoading(false);
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 };
    setPagination(newPagination);
    setPageSizeModalVisible(false);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData();
      setIsLeaveTypeAdd(false);
    }, 600);

    return () => {
      clearTimeout(handler);
    };
  }, [isLeaveTypeAdd]);

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        const response = await getAllLeaveTypes({ search: "", setLoading });
        const options = response.map((item) => ({
          value: item._id,
          label: item.name,
        }));
        setleaveTypeOptions(options);
        const department = await getAllDepartments({ search: "" });
        const dptOptions = department.map((item) => ({
          value: item._id,
          label: item.departmentName,
        }));
        setDepartmentOptions(dptOptions);
      } catch (error) {
        console.error("Error in fetching Service Names", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLeaveTypes();
  }, [setLoading]);

  const handleDeleteLeaveType = async (id) => {
    try {
      const response = await deleteLeaveAllocation(id);
      fetchData();
      toast.success(response.message || "Roster leave allocation deleted successfully.", {
        position: "top-right",
        autoClose: 3000, // 3-5 seconds as requested
      });
    } catch (error) {
      console.error("Error deleting Leave allocation:", error);
      toast.error(error.response?.data?.message || "Failed to delete leave allocation.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteLeaveType(id);
      } else {
        MySwal.close();
      }
    });
  };

  const handleViewModalOpen = (leaveBalances) => {
    setSelectedLeaveBalances(leaveBalances);
    setIsViewModalOpen(true);
    document.querySelector(".sidebar").style.pointerEvents = "none";
    document.querySelector(".sidebar").style.opacity = "0.5";
  };

  const handleViewModalClose = () => {
    setIsViewModalOpen(false);
    document.querySelector(".sidebar").style.pointerEvents = "auto";
    document.querySelector(".sidebar").style.opacity = "1";
  };

  const handleEditModalOpen = (leaveAllocation) => {
    setSelectedLeaveType(leaveAllocation);
    setIsEditModalOpen(true);
  };

  const handleSearch = async () => {
    const records = await fetchSearchAllocation({
      setLoading,
      finacialYear: searchYear,
      epf_number,
      name,
      employeeType: empType,
      department: selectedDepartment?.value,
      leaveType: selectedLeaveTypeOption?.label,
    });

    if (records) {
      setData(records);
    } else {
      setData([]);
    }
  };

  const handlePdfExport = () => {
    const date = dayjs().format("YYYY-MM-DD");
    const img = okilogo;

    const formattedData = data.flatMap((emp) => {
      return emp.leaveBalances.map((leave, index) => ({
        name: index === 0 ? `${emp.employee?.first_name || ""} ${emp.employee?.last_name || ""}` : "",
        number: index === 0 ? (emp.employee?.epf_number || emp.employee?.employee_id || "") : "",
        fYear: index === 0 ? emp.finacialYear : "",
        leaveType: leave.leaveType.name,
        leaveCount: leave.leaveCount,
        initialQuota: leave.initialQuota, // Include initialQuota
      }));
    });

    const doc = new jsPDF();

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(16);
    doc.text("OKI International ", 15, 13);

    doc.setFontSize(13);
    doc.setTextColor(138, 132, 125);
    doc.text(`Employees Leave Balances`, 15, 23);
    doc.text(`Date: ${date}`, 15, 30);
    doc.addImage(img, "PNG", 170, 8, 22, 25);

    doc.autoTable({
      head: [
        [
          "Employee Name",
          "Employee Number",
          "Financial Year",
          "Type",
          "Initial Quota",
          "Current Balance",
        ],
      ],
      body: formattedData.map((row) => [
        row.name,
        row.number,
        row.fYear,
        row.leaveType,
        row.initialQuota,
        row.leaveCount,
      ]),
      startY: 35,
      theme: "striped",
      headStyles: {
        fillColor: [138, 132, 125],
      },
    });

    doc.save("leave_balances.pdf");
  };

  const handleExcelExport = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Employees Leave Balances");

    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    worksheet.columns = [
      { header: "Employee Name", key: "name", width: 20 },
      { header: "Employee Number", key: "number", width: 20 },
      { header: "Financial Year", key: "fYear", width: 15 },
      { header: "Leave Type", key: "type", width: 30 },
      { header: "Initial Quota", key: "initialQuota", width: 15 }, // Add initialQuota
      { header: "Current Balance", key: "count", width: 15 },
    ];

    const formattedData = data.flatMap((emp) => {
      return emp.leaveBalances.map((leave, index) => ({
        name: index === 0 ? `${emp.employee?.first_name || ""} ${emp.employee?.last_name || ""}` : "",
        number: index === 0 ? (emp.employee?.epf_number || emp.employee?.employee_id || "") : "",
        fYear: index === 0 ? emp.finacialYear : "",
        type: leave.leaveType.name,
        initialQuota: leave.initialQuota,
        count: leave.leaveCount,
      }));
    });

    formattedData.forEach((row) => {
      worksheet.addRow({
        name: row.name,
        number: row.number,
        fYear: row.fYear,
        type: row.type,
        initialQuota: row.initialQuota,
        count: row.count,
      });
    });

    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = borderStyle;
      });
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Employees_Leave_Balances.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const columns = [
    {
      title: "Financial Year",
      dataIndex: "finacialYear",
      key: "finacialYear",
    },
    {
      title: "Employee Id",
      dataIndex: ["employee"],
      key: "employee_id",
      render: (employee) => `${employee?.epf_number || employee?.employee_id || ""}`,
    },
    {
      title: "Employee Name",
      dataIndex: ["employee"],
      key: "employee_name",
      render: (employee) => `${employee.full_name}`,
    },
    {
      title: "Employee Type",
      dataIndex: ["employee"],
      key: "employee_type",
      render: (employee) => `${employee.employee_type}`,
    },
    {
      title: "Department",
      dataIndex: ["employee"],
      key: "department",
      render: (employee) => `${employee.department_id?.departmentName}`,
    },
    {
      title: "Leave Balances",
      dataIndex: "leaveBalances",
      key: "leave_balances",
      render: (leaveBalances) => (
        <Table
          dataSource={leaveBalances}
          columns={[
            {
              title: <Tag color="orange" style={{ color: "black" }}>Leave Type</Tag>,
              dataIndex: ["leaveType", "name"],
              key: "leaveType_name",
              align: "left",
            },
            {
              title: <Tag color="orange" style={{ color: "black" }}>Initial Quota</Tag>,
              dataIndex: "initialQuota",
              key: "initialQuota",
              align: "left",
            },
            {
              title: <Tag color="orange" style={{ color: "black" }}>Current Balance</Tag>,
              dataIndex: "leaveCount",
              key: "leaveCount",
              align: "left",
            },
          ]}
          pagination={false}
          rowKey="leaveType"
        />
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (_, record) => (
        <td className="action-table-data">
          <Link
            className={`me-2 p-2 ${
              user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "edit", "Leave Allocation")
                ? ""
                : "disabled"
            }`}
            to="#"
            onClick={() => {
              if (user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "edit", "Leave Allocation")) {
                handleEditModalOpen(record);
              }
            }}
            title={
              !(user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "edit", "Leave Allocation"))
                ? "You don't have permission to edit leave allocations"
                : "Edit leave allocation"
            }
          >
            <i data-feather="edit" className="feather-edit"></i>
          </Link>
          <Link
            className="me-2 p-2"
            to="#"
            onClick={() => handleViewModalOpen(record.leaveBalances)}
          >
            <Eye className="feather-eye" />
          </Link>
          <Link
            className={`confirm-text p-2 ${
              user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "delete", "Leave Allocation")
                ? ""
                : "disabled"
            }`}
            to="#"
            onClick={() => {
              if (user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "delete", "Leave Allocation")) {
                showConfirmationAlert(record._id);
              }
            }}
            title={
              !(user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "delete", "Leave Allocation"))
                ? "You don't have permission to delete leave allocations"
                : "Delete leave allocation"
            }
          >
            <i data-feather="trash-2" className="feather-trash-2"></i>
          </Link>
        </td>
      ),
    },
  ];

  return (
    <div className="page-wrapper-lt">
      <ToastContainer />
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container">
              <div>
                <ArrowLeft size={32} />
              </div>
              <div className="page-title">
                <h4>Leaves Allocation</h4>
                <h6>Manage your Leaves</h6>
              </div>
            </div>
          </div>
          <div className="wordset">
            <ul>
              <li>
                <a
                  className={`${
                    user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "download", "Leave Allocation")
                      ? ""
                      : "disabled"
                  }`}
                  onClick={() => {
                    if (user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "download", "Leave Allocation")) {
                      handlePdfExport();
                    }
                  }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title={
                    !(user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "download", "Leave Allocation"))
                      ? "You don't have permission to export PDF"
                      : "Export to PDF"
                  }
                >
                  <img src="assets/img/icons/pdf.svg" alt="pdf" />
                </a>
              </li>
              <li>
                <a
                  className={`${
                    user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "download", "Leave Allocation")
                      ? ""
                      : "disabled"
                  }`}
                  onClick={() => {
                    if (user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "download", "Leave Allocation")) {
                      handleExcelExport();
                    }
                  }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title={
                    !(user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "download", "Leave Allocation"))
                      ? "You don't have permission to export Excel"
                      : "Export to Excel"
                  }
                >
                  <img src="assets/img/icons/excel.svg" alt="excel" />
                </a>
              </li>
              <div className="page-btn">
                <a
                  className={`btn btn-added-grid ${
                    user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "create", "Leave Allocation")
                      ? ""
                      : "disabled"
                  }`}
                  onClick={() => {
                    if (user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "create", "Leave Allocation")) {
                      setIsBulkUploadOpen(true);
                    }
                  }}
                  title={
                    !(user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "create", "Leave Allocation"))
                      ? "You don't have permission to bulk upload"
                      : "Bulk upload leave allocations"
                  }
                >
                  <PlusCircle className="me-2" />
                  Bulk
                </a>
              </div>
              <div className="page-btn">
                <a
                  className={`btn btn-added ${
                    user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "create", "Leave Allocation")
                      ? ""
                      : "disabled"
                  }`}
                  onClick={() => {
                    if (user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "create", "Leave Allocation")) {
                      setIsModalOpen(true);
                    }
                  }}
                  title={
                    !(user?.permissions && hasPermission(user.permissions, "HRM", "Leaves", "create", "Leave Allocation"))
                      ? "You don't have permission to allocate leaves"
                      : "Allocate leaves"
                  }
                >
                  <PlusCircle className="me-2" />
                  Allocate
                </a>
              </div>
            </ul>
          </div>
        </div>
        <div className="card table-list-card-grid">
          <div className="card-body" style={{ maxWidth: "100%", marginRight: "20px" }}>
            <div className="container mt-3" style={{ maxWidth: "100%", marginLeft: "20px", marginRight: "40px" }}>
              <div className="row d-flex flex-wrap align-items-start justify-content-between">
                <div className="col-12 col-md-3 text-start">
                  <label className="form-label">Employee Name</label>
                  <input
                    type="text"
                    value={name}
                    className="form-control"
                    onChange={(e) => setName(e.target.value)}
                    style={{ width: "100%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-1 mb-3 text-start">
                  <label className="form-label">EPF No</label>
                  <input
                    className="form-control"
                    type="text"
                    value={epf_number}
                    onChange={(e) => setEpf(e.target.value)}
                    style={{ width: "100%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Employee Type</label>
                  <Select
                    value={empType}
                    onChange={setEmpType}
                    className="select"
                    options={employeeTypes}
                    placeholder="Select Employee Type"
                    allowClear
                    style={{ width: "100%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Department</label>
                  <Select
                    value={selectedDepartment}
                    options={departmentOptions}
                    className="select"
                    placeholder="Select Department"
                    onChange={handleChangeDepartment}
                    allowClear
                    style={{ width: "100%", height: "40px" }}
                    showSearch
                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Leave Type</label>
                  <Select
                    className="select"
                    options={leaveTypeOptions}
                    placeholder="Select a leave type"
                    value={selectedLeaveTypeOption}
                    onChange={handleChangeLeaveType}
                    style={{ width: "100%", height: "40px" }}
                    allowClear
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Year</label>
                  <DatePicker
                    picker="year"
                    onChange={handleSearchYearChange}
                    defaultValue={dayjs(`${currentYear}`, "YYYY")}
                    placeholder="Select Year"
                    size="large"
                    style={{ width: "100%", borderRadius: 8 }}
                    allowClear
                  />
                </div>
              </div>
            </div>
            <div className="container mt-0" style={{ maxWidth: "100%", marginLeft: "20px", marginRight: "40px" }}>
              <div className="row d-flex align-items-center justify-content-start">
                <div className="col-12 col-md-2 mb-3 text-start">
                  <button
                    disabled={loading}
                    className="btn btn-submit"
                    onClick={handleSearch}
                    style={{ height: "38px", width: "55%" }}
                  >
                    {loading ? "Searching..." : "Search"}
                  </button>
                  {loading && (
                    <div className="spinner">
                      <div className="loading-circle"></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card table-list-card-grid">
          <div className="card-body">
            <div className="table-top"></div>
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={columns}
                dataSource={data}
                rowKey="_id"
                className="custom-ant-table-grid"
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: data.length,
                  pageSizeOptions: ["5", "10", "20", "50"],
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total) => `Total ${total} items`,
                }}
                onChange={handleTableChange}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        zIndex={1050}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <CreateLeaveTypeModal
          handleLeaveTypeAdding={() => {
            setIsLeaveTypeAdd(true);
            setIsModalOpen(false);
          }}
          handleCancel={() => setIsModalOpen(false)}
          selectedLeaveType={null}
        />
      </Modal>

      <Modal
        zIndex={1050}
        open={isEditModalOpen}
        onOk={() => setIsEditModalOpen(false)}
        onCancel={() => setIsEditModalOpen(false)}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <EditLeaveTypeModal
          handleEditLeaveType={() => {
            setIsLeaveTypeAdd(true);
            setIsEditModalOpen(false);
          }}
          handleCancel={() => setIsEditModalOpen(false)}
          selectedLeaveType={selectedLeaveType}
        />
      </Modal>

      <Modal
        zIndex={1050}
        open={isViewModalOpen}
        onOk={handleViewModalClose}
        onCancel={handleViewModalClose}
        footer={null}
        closable={false}
      >
        <div className="leave-balance-widget">
          <h5 style={{ marginBottom: "20px" }}>Leave Balances Overview</h5>
          <Table
            dataSource={selectedLeaveBalances}
            columns={[
              {
                title: "Leave Type",
                dataIndex: ["leaveType", "name"],
                key: "leaveType_name",
              },
              {
                title: "Initial Quota",
                dataIndex: "initialQuota",
                key: "initialQuota",
              },
              {
                title: "Current Balance",
                dataIndex: "leaveCount",
                key: "leaveCount",
              },
            ]}
            pagination={false}
            rowKey="leaveType"
            footer={() => (
              <div style={{ textAlign: "right", marginTop: "16px" }}>
                <button onClick={handleViewModalClose} className="btn btn-cancel">
                  Close
                </button>
              </div>
            )}
          />
        </div>
      </Modal>
      <BulkUploadModal
        handleCancel={() => setIsBulkUploadOpen(false)}
        isVisible={isBulkUploadOpen}
        onUploadData={fetchData}
      />
      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button key="cancel" className="btn btn-cancel" onClick={() => setPageSizeModalVisible(false)}>
            Cancel
          </button>,
          <button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select style={{ width: "100%" }} value={tempPageSize} onChange={(value) => setTempPageSize(value)}>
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </div>
  );
};

export default JobType;